<template>
    <div class="bg-white px-3 index" >
        <div class="add_tits" ref="titles">
            <el-form class="form-inlines " :inline="true">
                <div class="u-f u-ac u-jsb">
                    <el-form-item>
                        <el-button type="primary" icon="el-icon-search" size="small" @click="begin">搜索</el-button>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" icon="el-icon-circle-plus-outline" size="small" @click="handleAdd">新增
                        </el-button>
                    </el-form-item>
                </div>

            </el-form>
        </div>
        <div class="ibox-content">
            <el-table :data="tableData" :height="height" border v-loading="loading"  :span-method="getSpanMethod">
                <el-table-column prop="action" label="行为"></el-table-column>
                <el-table-column prop="detail" label="方式"></el-table-column>
                <el-table-column prop="kcurrency" label="积分"></el-table-column>
                <el-table-column prop="remark" label="备注" show-overflow-tooltip></el-table-column>
                <el-table-column label="操作" align="center">
                    <template slot-scope="scope">
                        <el-button size="mini" type="primary" icon="el-icon-edit-outline"
                            @click="handleEdit(scope.row,scope.$index)"></el-button>
                        <el-button size="mini" type="danger" icon="el-icon-delete"
                            @click="handleDelet(scope.row,scope.$index)"></el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <el-dialog title="规则设置" :visible.sync="dialogVisible" center top="20px" class="dialogs">
            <el-divider></el-divider>
            <div class="dialog-ibox-content">
                <el-form :model="ruleForm" :rules="rule" ref="ruleForm" label-width="150px" class="demo-ruleForm">
                    <el-form-item label="行为名称" prop='action'>
                        <el-input v-model="ruleForm.action" size="small"></el-input>
                    </el-form-item>
                    <el-form-item label="行为描述" prop='detail'>
                        <el-input v-model="ruleForm.detail" size="small"></el-input>
                    </el-form-item>
                    <el-form-item label="获得K币" prop='kcurrency'>
                        <el-input v-model="ruleForm.kcurrency" size="small"></el-input>
                    </el-form-item>
                    <el-form-item label="用户" prop='customer_type'>
                        <el-select v-model="ruleForm.customer_type" placeholder="请选择" size="small">
                            <el-option label="用户" value="1"></el-option>
                            <el-option label="专家" value="2"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="来源" prop='source'>
                        <el-select v-model="ruleForm.source" placeholder="请选择" size="small">
                            <el-option label="用户表" value="1"></el-option>
                            <el-option label="健康头条表" value="2"></el-option>
                            <el-option label="活动表" value="3"></el-option>
                            <el-option label="字典问答表" value="4"></el-option>
                            <el-option label="订单表" value="5"></el-option>
                            <el-option label="6专家入驻表" value="6"></el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
            </div>
            <el-divider></el-divider>
            <span slot="footer" class="dialog-footer">
                <el-button @click="submit('ruleForm')" size="small" type="primary" :loading="subloading">提 交</el-button>
                <el-button @click="dialogVisible = false" size="small">取 消</el-button>
            </span>
        </el-dialog>

    </div>
</template>


<script>
    import {
        mapState
    } from 'vuex'
    export default {
        data() {
            return {
                loading: false,
                tableData: [],
                height: null,
                spanArr:[],
                // 
                eid: '',
                dialogVisible: false,
                subloading: false,
                ruleForm: {
                    action: '',
                    detail: '',
                    kcurrency: '',
                    customer_type: '',
                    source: '',
                },
                rule: {
                    action: [{
                        required: true,
                        message: '请填写行为名称',
                        trigger: 'blur'
                    }],
                    detail: [{
                        required: true,
                        message: '请填写行为描述',
                        trigger: 'blur'
                    }],
                    kcurrency: [{
                        required: true,
                        message: '请填写获得K币',
                        trigger: 'blur'
                    }],
                    customer_type: [{
                        required: true,
                        message: '请填写用户',
                        trigger: 'blur'
                    }],
                    source: [{
                        required: true,
                        message: '请填写来源',
                        trigger: 'blur'
                    }],
                }
            };
        },
        computed: {
            ...mapState({
                user: state => state.user.user,
            })
        },
        mounted() {
            let that = this
            that.getHeight()
            that.begin()
        },
        methods: {
            getHeight() {
                let that = this
                var titles = that.$refs.titles.offsetHeight
                that.height = window.innerHeight - titles - 200 + 'px'
                window.onresize = () => {
                    var titles = that.$refs.titles.offsetHeight
                    that.height = window.innerHeight - titles - 200 + 'px'
                }
            },
            // 搜索
            begin() {
                let that = this
                that.search()
            },
            search() {
                let that = this
                that.loading = true
                axios.post("/admin/KcurrencyRule/ruleList", {
                        page: this.currentPage,
                        page_count: that.pagesize
                    }, {
                        token: true
                    })
                    .then(response => {
                        that.loading = false
                        that.tableData = response.data.data
                        this.setdates()
                    })
                    .catch(error => {})
            },
            setdates() {
                let contactDot = 0;
                this.spanArr = []
                this.tableData.forEach((item, index) => {
                    item.index = index;
                    if (index === 0) {
                        this.spanArr.push(1);
                    } else {
                        if (item.action === this.tableData[index - 1].action) {
                            this.spanArr[contactDot] += 1;
                            this.spanArr.push(0);
                        } else {
                            contactDot = index;
                            this.spanArr.push(1);
                        }
                      
                    }
                });
            },
            getSpanMethod({
                row,
                column,
                rowIndex,
                columnIndex
            }) {
                if (columnIndex === 0) { //合并第一列
                    const _row = this.spanArr[rowIndex];
                    const _col = _row > 0 ? 1 : 0;
                    return {
                        rowspan: _row,
                        colspan: _col
                    };
                }
            },
            handleAdd() {
                let that = this
                that.dialogVisible = true
                that.eid = ''
                that.form_clear()
            },
            form_clear() {
                let that = this
                that.ruleForm = {
                    action: '',
                    detail: '',
                    kcurrency: '',
                    customer_type: '',
                    source: '',
                }
            },
            submit(formName) {
                let that = this
                that.$refs[formName].validate((valid) => {
                    if (valid) {
                        that.subloading = true
                        let urls;
                        if (this.eid) {
                            urls = "/admin/KcurrencyRule/update"
                        } else {
                            urls = "/admin/KcurrencyRule/save"
                        }
                        axios.post(urls, {
                                id: that.eid,
                                action: that.ruleForm.action,
                                detail: that.ruleForm.detail,
                                kcurrency: that.ruleForm.kcurrency,
                                customer_type: that.ruleForm.customer_type,
                                source: that.ruleForm.source,
                                pid:0,
                            }, {
                                token: true
                            })
                            .then(response => {
                                that.subloading = false
                                if (response.data.code == '200') {
                                    that.dialogVisible = false
                                    that.search()
                                    that.$message({
                                        message: '操作成功',
                                        type: 'success'
                                    });
                                } else {
                                    that.$message.error(response.data.msg);
                                }
                            })
                            .catch(error => {
                                that.subloading = false
                            })
                    } else {
                        return false;
                    }
                });
            },
            // 编辑
            handleEdit(row, index) {
                let that = this
                that.form_clear()
                that.dialogVisible = true
                that.eid = row.id
                axios
                    .post("/admin/KcurrencyRule/read", {
                        id: that.eid,
                    }, {
                        token: true
                    })
                    .then(response => {
                        var data = response.data.data
                        that.ruleForm.action = data.action
                        that.ruleForm.detail = data.detail
                        that.ruleForm.kcurrency = data.kcurrency
                        that.ruleForm.customer_type = data.customer_type?data.customer_type.toString():''
                        that.ruleForm.source = data.source?data.source.toString():''
                    })
                    .catch(error => {})
            },
            // 删除
            handleDelet(row, index) {
                let that = this
                this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    axios
                        .post("/admin/KcurrencyRule/del", {
                            id: row.id,
                        }, {
                            token: true
                        })
                        .then(response => {
                            if (response.data.code == '200') {
                                this.$message({
                                    type: 'success',
                                    message: '删除成功!'
                                });
                                that.search()
                            } else {
                                that.$message.error(response.data.msg);
                            }
                        })
                        .catch(error => {})
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            }
        },

    };
</script>


<style scoped>
</style>